/* Brain2Canvas — Spray Studio engine v2.
   Motive (Untergründe) mit Pfeil-Navigation, echte Cap-Profile, Nebel-Physik.
   Erwartet: #ss-stage, #wallbg, #wallpaint, #spraycap, .ss-color (data-color),
   .ss-cap (data-cap), [data-tool], #ss-undo #ss-clear #ss-save #ss-share #ss-sound,
   #ss-prev #ss-next #ss-surface. */
(function () {
  function ready(fn){ if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn); else fn(); }
  ready(function () {
    var stage = document.getElementById('ss-stage');
    var bg = document.getElementById('wallbg'), paint = document.getElementById('wallpaint');
    var sten = document.getElementById('wallsten');
    var cap = document.getElementById('spraycap');
    if (!stage || !bg || !paint) return;
    var bctx = bg.getContext('2d'), pctx = paint.getContext('2d');
    var sctx = sten ? sten.getContext('2d') : null;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0;

    /* ---------- Cap-Profile (an echte Caps angelehnt) ----------
       rad: Streuradius px · core: Anteil deckender Kern · mist: Nebel-Reichweite (xrad)
       budget: Partikel pro Stempel · drip: Drip-Neigung · dirty: Sprenkel weit außen */
    var CAPS = {
      skinny:   { rad: 7,  core: .8,  mist: 1.5, budget: 60,  drip: .25, dirty: 0 },
      standard: { rad: 9,  core: .55, mist: 2.0, budget: 70,  drip: .45, dirty: .3 },
      soft:     { rad: 15, core: .6,  mist: 1.9, budget: 110, drip: .4,  dirty: 0 },
      fat:      { rad: 27, core: .55, mist: 2.2, budget: 170, drip: .8,  dirty: 0 }
    };
    var state = { color: '#ff3b30', cap: 'soft', tool: 'spray', sound: false, soundUserSet: false, surface: 0, stencil: null, stenX: 0, stenY: 0 };
    var drips = [], spraying = false, last = null, dwell = 0, undoStack = [], acc = 0, surfMask = null;

    /* ================= MOTIVE ================= */
    function grain(amount) {
      for (var i = 0; i < (W*H)/amount; i++) {
        var a = Math.random()*0.05;
        bctx.fillStyle = Math.random() > .5 ? 'rgba(255,255,255,'+a+')' : 'rgba(0,0,0,'+(a*1.5)+')';
        bctx.fillRect(Math.random()*W, Math.random()*H, 1.4, 1.4);
      }
    }
    function vign(s) {
      var v = bctx.createRadialGradient(W/2, H/2, Math.min(W,H)*0.25, W/2, H/2, Math.max(W,H)*0.75);
      v.addColorStop(0, 'rgba(0,0,0,0)'); v.addColorStop(1, 'rgba(0,0,0,'+s+')');
      bctx.fillStyle = v; bctx.fillRect(0, 0, W, H);
    }
    function rr(c, x, y, w, h, r) { c.beginPath(); c.moveTo(x+r,y); c.arcTo(x+w,y,x+w,y+h,r); c.arcTo(x+w,y+h,x,y+h,r); c.arcTo(x,y+h,x,y,r); c.arcTo(x,y,x+w,y,r); c.closePath(); }

    function drawConcrete() {
      // echte helle Betonwand mit Schaltafel-Fugen und Ankerlöchern
      var g = bctx.createLinearGradient(0, 0, 0, H);
      g.addColorStop(0, '#a6a49c'); g.addColorStop(.5, '#93918a'); g.addColorStop(1, '#7e7c75');
      bctx.fillStyle = g; bctx.fillRect(0, 0, W, H);
      // wolkige Tönung
      for (var i = 0; i < 9; i++) {
        var sx = Math.random()*W, sy = Math.random()*H, sr = 100+Math.random()*260;
        var st = bctx.createRadialGradient(sx, sy, 0, sx, sy, sr);
        var dk = Math.random() > .5;
        st.addColorStop(0, dk ? 'rgba(60,58,52,.10)' : 'rgba(255,255,250,.08)'); st.addColorStop(1, 'rgba(0,0,0,0)');
        bctx.fillStyle = st; bctx.beginPath(); bctx.arc(sx, sy, sr, 0, 6.283); bctx.fill();
      }
      // Regen-Schlieren von oben
      for (var r2 = 0; r2 < 14; r2++) {
        var rx = Math.random()*W, rl = 60+Math.random()*H*0.4;
        var rg = bctx.createLinearGradient(0, 0, 0, rl);
        rg.addColorStop(0, 'rgba(70,68,62,.12)'); rg.addColorStop(1, 'rgba(70,68,62,0)');
        bctx.fillStyle = rg; bctx.fillRect(rx, 0, 2+Math.random()*5, rl);
      }
      // Schaltafel-Fugen
      var cols = Math.max(3, Math.round(W/330)), rows = 2;
      bctx.strokeStyle = 'rgba(50,48,44,.35)'; bctx.lineWidth = 2;
      for (var c = 1; c < cols; c++) {
        var jx = W*c/cols;
        bctx.beginPath(); bctx.moveTo(jx, 0); bctx.lineTo(jx, H); bctx.stroke();
        bctx.fillStyle = 'rgba(255,255,250,.18)'; bctx.fillRect(jx+1, 0, 1.5, H);
      }
      for (var rw = 1; rw < rows; rw++) {
        var jy = H*rw/rows;
        bctx.beginPath(); bctx.moveTo(0, jy); bctx.lineTo(W, jy); bctx.stroke();
        bctx.fillStyle = 'rgba(255,255,250,.18)'; bctx.fillRect(0, jy+1, W, 1.5);
      }
      // Ankerlöcher
      for (var c2 = 0; c2 < cols; c2++) for (var rw2 = 0; rw2 < rows; rw2++) {
        var ax = W*(c2+0.5)/cols, ay = H*(rw2+0.5)/rows;
        [[ -0.38,-0.34],[0.38,-0.34],[-0.38,0.34],[0.38,0.34]].forEach(function (o) {
          var hx = ax + o[0]*W/cols, hy = ay + o[1]*H/rows;
          var hg = bctx.createRadialGradient(hx-1, hy-1, 0, hx, hy, 7);
          hg.addColorStop(0, '#55534d'); hg.addColorStop(.75, '#6e6c65'); hg.addColorStop(1, 'rgba(0,0,0,0)');
          bctx.fillStyle = hg; bctx.beginPath(); bctx.arc(hx, hy, 7, 0, 6.283); bctx.fill();
          bctx.fillStyle = 'rgba(255,255,250,.35)'; bctx.beginPath(); bctx.arc(hx+2, hy+2.5, 2.5, 0, 6.283); bctx.fill();
        });
      }
      grain(1600); vign(.3);
      // Boden-Sockel
      bctx.fillStyle = 'rgba(40,38,34,.55)'; bctx.fillRect(0, H-16, W, 16);
      bctx.fillStyle = 'rgba(255,255,250,.12)'; bctx.fillRect(0, H-16, W, 2);
    }

    function drawUbahn() {
      // Berliner Bahnhof: geflieste Wand + Bahnsteig
      bctx.fillStyle = '#cfc9b8'; bctx.fillRect(0, 0, W, H);
      var tw = 46, th = 22;
      bctx.strokeStyle = 'rgba(0,0,0,.10)'; bctx.lineWidth = 1;
      for (var ty = 0; ty < H; ty += th) {
        var off = (ty/th)%2 ? tw/2 : 0;
        for (var tx = -tw; tx < W; tx += tw) { bctx.strokeRect(tx+off, ty, tw, th); }
      }
      var shade0 = bctx.createLinearGradient(0,0,0,H*0.3);
      shade0.addColorStop(0,'rgba(0,0,0,.35)'); shade0.addColorStop(1,'rgba(0,0,0,0)');
      bctx.fillStyle = shade0; bctx.fillRect(0,0,W,H*0.3);
      // Stations-Schild hängend (links, unter dem Hint)
      var sgw = Math.min(W*0.3, 330), sgx = W*0.035, sgy = H*0.075;
      bctx.fillStyle = 'rgba(0,0,0,.3)'; bctx.fillRect(sgx+4, sgy+4, sgw, 40);
      bctx.fillStyle = '#f4f2ea'; bctx.fillRect(sgx, sgy, sgw, 40);
      bctx.fillStyle = '#1d3e8f'; bctx.fillRect(sgx, sgy, 44, 40);
      bctx.fillStyle = '#fff'; bctx.font = '800 26px \'Unbounded\',sans-serif'; bctx.textAlign = 'center';
      bctx.fillText('U', sgx+22, sgy+30);
      bctx.fillStyle = '#15151a'; bctx.font = '700 ' + Math.min(19, sgw*0.075) + "px 'Hanken Grotesk',sans-serif";
      bctx.fillText('SCHLESISCHES TOR', sgx+22+(sgw-44)/2+11, sgy+27);
      var top = H*0.24, bot = H*0.85, bodyH = bot-top;
      // Schatten des Zugs auf Gleisbett
      bctx.fillStyle = 'rgba(0,0,0,.4)'; bctx.fillRect(0, bot+2, W, 10);
      // Wagenkasten — Verkehrsgelb, plastisch (vertikale Rundung)
      var body = bctx.createLinearGradient(0, top, 0, bot);
      body.addColorStop(0, '#c7a800'); body.addColorStop(.08, '#f7d81f'); body.addColorStop(.22, '#ffe95e');
      body.addColorStop(.45, '#F0CA00'); body.addColorStop(.8, '#d3b100'); body.addColorStop(1, '#9d8400');
      bctx.fillStyle = body; rr(bctx, -24, top, W+48, bodyH, 30); bctx.fill();
      // Dach
      var roof = bctx.createLinearGradient(0, top-14, 0, top+4);
      roof.addColorStop(0, '#7e7e85'); roof.addColorStop(1, '#3c3c42');
      bctx.fillStyle = roof; rr(bctx, -24, top-12, W+48, 20, 10); bctx.fill();
      // Fensterband mit Spiegelung
      var wy = top + bodyH*0.13, wh = bodyH*0.32;
      bctx.fillStyle = '#0e0e12'; rr(bctx, W*0.015, wy, W*0.97, wh, 12); bctx.fill();
      bctx.save(); rr(bctx, W*0.015, wy, W*0.97, wh, 12); bctx.clip();
      var refl = bctx.createLinearGradient(0, wy, 0, wy+wh);
      refl.addColorStop(0, 'rgba(255,255,255,.34)'); refl.addColorStop(.35, 'rgba(255,255,255,.06)'); refl.addColorStop(1, 'rgba(255,255,255,0)');
      bctx.fillStyle = refl; bctx.fillRect(W*0.015, wy, W*0.97, wh);
      bctx.fillStyle = 'rgba(255,255,255,.08)';
      for (var rx = 0; rx < W; rx += W/5) { bctx.beginPath(); bctx.moveTo(rx, wy+wh); bctx.lineTo(rx+wh*0.9, wy); bctx.lineTo(rx+wh*1.25, wy); bctx.lineTo(rx+wh*0.35, wy+wh); bctx.closePath(); bctx.fill(); }
      bctx.restore();
      // Fensterstege + Türen (vertieft)
      var n = Math.max(4, Math.round(W/300));
      for (var i = 1; i < n; i++) {
        var dx = W*0.015 + (W*0.97)*(i/n);
        bctx.fillStyle = '#e3c206'; bctx.fillRect(dx-15, wy-2, 30, wh+4);
        bctx.fillStyle = 'rgba(255,255,255,.3)'; bctx.fillRect(dx-15, wy-2, 3, wh+4);
        var doorTop = wy+wh+10, doorBot = bot-bodyH*0.15;
        var dg = bctx.createLinearGradient(dx-34, 0, dx+34, 0);
        dg.addColorStop(0, 'rgba(0,0,0,.24)'); dg.addColorStop(.12, 'rgba(0,0,0,0)'); dg.addColorStop(.88, 'rgba(0,0,0,0)'); dg.addColorStop(1, 'rgba(0,0,0,.24)');
        bctx.fillStyle = dg; rr(bctx, dx-34, doorTop, 68, doorBot-doorTop, 6); bctx.fill();
        bctx.strokeStyle = 'rgba(0,0,0,.35)'; bctx.lineWidth = 2;
        rr(bctx, dx-34, doorTop, 68, doorBot-doorTop, 6); bctx.stroke();
        bctx.beginPath(); bctx.moveTo(dx, doorTop+4); bctx.lineTo(dx, doorBot-4); bctx.stroke();
        bctx.fillStyle = '#101014'; rr(bctx, dx-26, doorTop+8, 22, 30, 3); bctx.fill(); rr(bctx, dx+4, doorTop+8, 22, 30, 3); bctx.fill();
      }
      // Zierlinie + Nummer + Zielanzeige
      bctx.fillStyle = '#15151a'; bctx.fillRect(-24, bot-bodyH*0.13, W+48, 4);
      bctx.font = '700 ' + Math.max(14, H*0.02) + "px 'Unbounded',sans-serif"; bctx.textAlign = 'left';
      bctx.fillStyle = '#15151a'; bctx.fillText('2734-B', W*0.03, bot-bodyH*0.045);
      bctx.fillStyle = '#101014'; rr(bctx, W*0.79, top+10, W*0.17, 26, 4); bctx.fill();
      bctx.fillStyle = '#ffb400'; bctx.font = '700 15px \'Hanken Grotesk\',sans-serif'; bctx.textAlign = 'center';
      bctx.fillText('U1 · WARSCHAUER STR.', W*0.875, top+28);
      // Unterboden + Bahnsteigkante
      bctx.fillStyle = '#2b2b30'; bctx.fillRect(0, bot, W, H-bot);
      var pf = bctx.createLinearGradient(0, bot+10, 0, H);
      pf.addColorStop(0, '#6b6b72'); pf.addColorStop(1, '#4a4a51');
      bctx.fillStyle = pf; bctx.fillRect(0, bot+12, W, H-bot);
      bctx.fillStyle = '#d9d9de'; bctx.fillRect(0, bot+12, W, 5);
      bctx.fillStyle = 'rgba(255,255,255,.5)';
      for (var px2 = 8; px2 < W; px2 += 34) bctx.fillRect(px2, bot+22, 18, 4); // Blindenleitstreifen
      grain(4200); vign(.24);
      // Nur der Wagen ist besprühbar (nicht Wand/Bahnsteig)
      surfMask = new Path2D();
      if (surfMask.roundRect) surfMask.roundRect(-24, top-12, W+48, bodyH+12, 30);
      else surfMask.rect(-24, top-12, W+48, bodyH+12);
    }

    function drawSticker() {
      // ruhiger Verlauf, Sticker schwebt plastisch
      var g = bctx.createRadialGradient(W*0.5, H*0.36, 60, W*0.5, H*0.6, Math.max(W,H)*0.85);
      g.addColorStop(0, '#8f95c9'); g.addColorStop(1, '#565d99');
      bctx.fillStyle = g; bctx.fillRect(0, 0, W, H);
      grain(5200);
      var w = Math.min(W*0.68, H*1.0), h = w*0.64, x = W/2, y = H/2;
      // weicher Bodenschatten (schweben)
      bctx.save(); bctx.translate(x, y+h*0.56); bctx.scale(1, 0.22);
      var fs = bctx.createRadialGradient(0, 0, 0, 0, 0, w*0.55);
      fs.addColorStop(0, 'rgba(20,20,40,.5)'); fs.addColorStop(1, 'rgba(20,20,40,0)');
      bctx.fillStyle = fs; bctx.beginPath(); bctx.arc(0, 0, w*0.55, 0, 6.283); bctx.fill(); bctx.restore();
      bctx.save(); bctx.translate(x, y); bctx.rotate(-2.5*Math.PI/180); bctx.translate(-w/2, -h/2);
      bctx.shadowColor = 'rgba(10,10,30,.45)'; bctx.shadowBlur = 44; bctx.shadowOffsetY = 22;
      bctx.fillStyle = '#fff'; rr(bctx, 0, 0, w, h, 18); bctx.fill();
      bctx.shadowColor = 'transparent';
      // Papier-Wölbung
      var pg = bctx.createLinearGradient(0, 0, w, 0);
      pg.addColorStop(0, 'rgba(0,0,0,.07)'); pg.addColorStop(.2, 'rgba(0,0,0,0)'); pg.addColorStop(.82, 'rgba(0,0,0,0)'); pg.addColorStop(1, 'rgba(0,0,0,.09)');
      bctx.fillStyle = pg; rr(bctx, 0, 0, w, h, 18); bctx.fill();
      var band = bctx.createLinearGradient(0, 0, 0, h*0.37);
      band.addColorStop(0, '#ef4b46'); band.addColorStop(1, '#d92f2c');
      bctx.fillStyle = band; bctx.beginPath();
      bctx.moveTo(18,0); bctx.arcTo(w,0,w,h*0.37,18); bctx.lineTo(w,h*0.37); bctx.lineTo(0,h*0.37); bctx.lineTo(0,18); bctx.arcTo(0,0,18,0,18); bctx.closePath(); bctx.fill();
      bctx.fillStyle = '#fff'; bctx.textAlign = 'center';
      bctx.font = '800 ' + (h*0.15) + "px 'Unbounded',sans-serif"; bctx.fillText('HELLO', w/2, h*0.19);
      bctx.font = '700 ' + (h*0.05) + "px 'Hanken Grotesk',sans-serif"; bctx.fillText('MY NAME IS', w/2, h*0.30);
      // Eselsohr unten rechts
      bctx.fillStyle = 'rgba(0,0,0,.12)'; bctx.beginPath();
      bctx.moveTo(w, h-56); bctx.lineTo(w, h-18); bctx.arcTo(w, h, w-18, h, 18); bctx.lineTo(w-56, h); bctx.closePath(); bctx.fill();
      var curl = bctx.createLinearGradient(w-56, h, w, h-56);
      curl.addColorStop(0, '#e9e6dd'); curl.addColorStop(.6, '#ffffff'); curl.addColorStop(1, '#d3d0c6');
      bctx.fillStyle = curl; bctx.beginPath();
      bctx.moveTo(w-56, h); bctx.lineTo(w, h-56); bctx.lineTo(w-14, h-8); bctx.closePath(); bctx.fill();
      bctx.restore(); vign(.2);
    }

    function drawShutter() {
      // NYC-Fassade: Backstein + Deli-Schild + Shutter + Gehweg
      var bw = 62, bh = 26;
      bctx.fillStyle = '#5e3a30'; bctx.fillRect(0, 0, W, H);
      for (var by = 0; by < H; by += bh) {
        var off = (by/bh)%2 ? bw/2 : 0;
        for (var bx2 = -bw; bx2 < W; bx2 += bw) {
          var tone = 0.85 + Math.random()*0.3;
          bctx.fillStyle = 'rgb('+Math.round(122*tone)+','+Math.round(74*tone)+','+Math.round(60*tone)+')';
          bctx.fillRect(bx2+off+1.5, by+1.5, bw-3, bh-3);
          if (Math.random()<0.08) { bctx.fillStyle='rgba(0,0,0,.18)'; bctx.fillRect(bx2+off+1.5, by+1.5, bw-3, bh-3); }
        }
      }
      var wsh = bctx.createLinearGradient(0,0,0,H);
      wsh.addColorStop(0,'rgba(0,0,0,.42)'); wsh.addColorStop(.3,'rgba(0,0,0,.08)'); wsh.addColorStop(1,'rgba(0,0,0,.3)');
      bctx.fillStyle = wsh; bctx.fillRect(0,0,W,H);
      // Gehweg
      var sw0 = H*0.9;
      bctx.fillStyle = '#54545b'; bctx.fillRect(0, sw0, W, H-sw0);
      bctx.fillStyle = '#6a6a72'; bctx.fillRect(0, sw0, W, 6);
      bctx.strokeStyle = 'rgba(0,0,0,.3)'; bctx.lineWidth = 2;
      for (var gx = W*0.1; gx < W; gx += W*0.24) { bctx.beginPath(); bctx.moveTo(gx, sw0+8); bctx.lineTo(gx-14, H); bctx.stroke(); }
      // Ladenfront-Rahmen
      var fx = W*0.14, fw = W*0.72, signH = Math.max(54, H*0.115), sy0 = H*0.1;
      bctx.fillStyle = 'rgba(0,0,0,.35)'; bctx.fillRect(fx-14, sy0-8, fw+28, sw0-sy0+8);
      // Deli-Schild
      var sg = bctx.createLinearGradient(0, sy0, 0, sy0+signH);
      sg.addColorStop(0, '#1d5c3c'); sg.addColorStop(1, '#123f28');
      bctx.fillStyle = sg; bctx.fillRect(fx-10, sy0, fw+20, signH);
      bctx.fillStyle = 'rgba(255,255,255,.08)'; bctx.fillRect(fx-10, sy0, fw+20, 5);
      bctx.fillStyle = '#fbe785'; bctx.font = '800 ' + (signH*0.42) + "px 'Unbounded',sans-serif"; bctx.textAlign = 'center';
      bctx.fillText('B2C DELI · GROCERY · 24H', W/2, sy0+signH*0.62);
      bctx.fillStyle = 'rgba(0,0,0,.45)'; bctx.fillRect(fx-10, sy0+signH, fw+20, 10);
      // Shutter-Lamellen
      var shy = sy0+signH+10, lam = Math.max(15, H*0.042);
      for (var y = shy; y < sw0; y += lam) {
        var l = bctx.createLinearGradient(0, y, 0, y+lam);
        l.addColorStop(0, '#5a5a61'); l.addColorStop(.32, '#94949c'); l.addColorStop(.55, '#70707a'); l.addColorStop(.82, '#43434a'); l.addColorStop(1, '#2e2e34');
        bctx.fillStyle = l; bctx.fillRect(fx, y, fw, Math.min(lam, sw0-y));
        bctx.fillStyle = 'rgba(0,0,0,.4)'; bctx.fillRect(fx, y, fw, 1.5);
      }
      var shs = bctx.createLinearGradient(fx, 0, fx+fw, 0);
      shs.addColorStop(0,'rgba(0,0,0,.3)'); shs.addColorStop(.12,'rgba(0,0,0,0)'); shs.addColorStop(.88,'rgba(0,0,0,0)'); shs.addColorStop(1,'rgba(0,0,0,.3)');
      bctx.fillStyle = shs; bctx.fillRect(fx, shy, fw, sw0-shy);
      // Führungsschienen
      var rail = bctx.createLinearGradient(fx-12, 0, fx, 0);
      rail.addColorStop(0, '#3a3a41'); rail.addColorStop(1, '#1c1c21');
      bctx.fillStyle = rail; bctx.fillRect(fx-12, shy-4, 12, sw0-shy+4);
      bctx.fillStyle = rail; bctx.fillRect(fx+fw, shy-4, 12, sw0-shy+4);
      // Schloss
      bctx.fillStyle = '#22222a'; rr(bctx, W/2-26, sw0-26, 52, 16, 4); bctx.fill();
      grain(4600); vign(.3);
    }

    var SURFACES = [
      { draw: drawConcrete },
      { draw: drawUbahn },
      { draw: drawSticker },
      { draw: drawShutter }
    ];

    function sticker(x, y, deg, accent) {
      var w = Math.min(190, W*0.22), h = w*0.62;
      bctx.save(); bctx.translate(x, y); bctx.rotate(deg*Math.PI/180); bctx.translate(-w/2, -h/2);
      bctx.shadowColor = 'rgba(0,0,0,.45)'; bctx.shadowBlur = 14; bctx.shadowOffsetY = 6;
      bctx.fillStyle = '#fff'; rr(bctx, 0, 0, w, h, 7); bctx.fill();
      bctx.shadowColor = 'transparent';
      bctx.fillStyle = accent; bctx.fillRect(0, 0, w, h*0.42);
      bctx.fillStyle = '#fff'; bctx.font = '700 ' + (h*0.18) + "px 'Unbounded',sans-serif";
      bctx.textAlign = 'center'; bctx.fillText('HELLO', w/2, h*0.27);
      bctx.fillStyle = '#15151a'; bctx.font = '800 ' + (h*0.16) + "px 'Unbounded',sans-serif";
      bctx.fillText('my name is', w/2, h*0.62);
      bctx.restore();
    }
    function slap(x, y, deg) {
      var s = Math.min(96, W*0.1);
      bctx.save(); bctx.translate(x, y); bctx.rotate(deg*Math.PI/180);
      bctx.shadowColor = 'rgba(0,0,0,.4)'; bctx.shadowBlur = 10; bctx.shadowOffsetY = 4;
      bctx.fillStyle = '#f3f1e9'; rr(bctx, -s/2, -s*0.32, s, s*0.64, 5); bctx.fill();
      bctx.shadowColor = 'transparent';
      bctx.fillStyle = '#15151a'; bctx.font = '900 ' + (s*0.26) + "px 'Unbounded',sans-serif";
      bctx.textAlign = 'center'; bctx.fillText('B2C', 0, s*0.09);
      bctx.restore();
    }

    function setSurface(i, keepPaint) {
      state.surface = ((i % SURFACES.length) + SURFACES.length) % SURFACES.length;
      surfMask = null;
      SURFACES[state.surface].draw();
      if (!keepPaint) { drips.length = 0; undoStack.length = 0; pctx.clearRect(0, 0, W, H); }
      var lbl = document.getElementById('ss-surface');
      if (lbl) lbl.textContent = T.surfaces[state.surface] + ' · ' + (state.surface+1) + '/' + SURFACES.length;
    }

    /* ================= SIZING ================= */
    function resize() {
      var r = stage.getBoundingClientRect();
      var nw = Math.max(1, Math.round(r.width)), nh = Math.max(1, Math.round(r.height));
      var prev = (W && H) ? pctx.getImageData(0, 0, paint.width, paint.height) : null;
      [bg, paint, sten].forEach(function (c) { if(!c)return; c.width = Math.round(nw*dpr); c.height = Math.round(nh*dpr); c.style.width = nw+'px'; c.style.height = nh+'px'; });
      W = nw; H = nh;
      bctx.setTransform(dpr,0,0,dpr,0,0); pctx.setTransform(dpr,0,0,dpr,0,0);
      if (sctx) sctx.setTransform(dpr,0,0,dpr,0,0);
      setSurface(state.surface, true);
      drawStencil();
      if (prev) { try { pctx.putImageData(prev, 0, 0); } catch (e) {} }
    }

    /* ================= STENCILS ================= */
    var STENCILS = {
      star:  'M0.5 0 L0.618 0.363 L1 0.382 L0.691 0.606 L0.809 1 L0.5 0.76 L0.191 1 L0.309 0.606 L0 0.382 L0.382 0.363 Z',
      bolt:  'M0.58 0 L0.12 0.58 L0.4 0.6 L0.28 1 L0.88 0.4 L0.56 0.38 Z',
      heart: 'M0.5 0.95 L0.14 0.58 C-0.08 0.34 0.06 0.02 0.32 0.02 C0.44 0.02 0.5 0.14 0.5 0.22 C0.5 0.14 0.56 0.02 0.68 0.02 C0.94 0.02 1.08 0.34 0.86 0.58 Z',
      crown: 'M0.06 0.88 L0.06 0.32 L0.3 0.54 L0.5 0.08 L0.7 0.54 L0.94 0.32 L0.94 0.88 Z'
    };
    function stenGeom() { var s = Math.min(W, H)*0.52; return { s: s, x: W/2 - s/2 + (state.stenX||0), y: H/2 - s/2 + (state.stenY||0) }; }
    function stenPath(ctx2) {
      var g = stenGeom(), p = new Path2D(STENCILS[state.stencil]);
      var m = new DOMMatrix(); m = m.translate(g.x, g.y).scale(g.s);
      var out = new Path2D(); out.addPath(p, m); return out;
    }
    var stenDrag = document.getElementById('ss-sten-drag');
    function positionStenDrag() {
      if (!stenDrag) return;
      if (!state.stencil) { stenDrag.hidden = true; return; }
      var g = stenGeom();
      stenDrag.hidden = false;
      stenDrag.style.left = g.x + 'px'; stenDrag.style.top = g.y + 'px';
      stenDrag.style.width = g.s + 'px'; stenDrag.style.height = g.s + 'px';
    }
    function drawStencil() {
      if (!sctx) return;
      sctx.clearRect(0, 0, W, H);
      positionStenDrag();
      if (!state.stencil) return;
      // Pappe über allem, Loch ausgeschnitten
      sctx.fillStyle = 'rgba(16,16,20,.42)'; sctx.fillRect(0, 0, W, H);
      sctx.globalCompositeOperation = 'destination-out';
      sctx.fill(stenPath());
      sctx.globalCompositeOperation = 'source-over';
      var g = stenGeom();
      sctx.strokeStyle = 'rgba(243,241,233,.65)'; sctx.setLineDash([7,6]); sctx.lineWidth = 2;
      sctx.stroke(stenPath()); sctx.setLineDash([]);
      sctx.font = "700 12px 'Unbounded',sans-serif"; sctx.textAlign = 'center';
      sctx.fillStyle = 'rgba(243,241,233,.55)';
      sctx.fillText('STENCIL AUFGELEGT — NOCHMAL KLICKEN ZUM ABNEHMEN', W/2, g.y + g.s + 30);
    }
    function clipStencil() { if (surfMask) pctx.clip(surfMask); if (state.stencil) pctx.clip(stenPath()); }

    /* ================= SPRAY (Sprite-Engine) =================
       Pro Cap 4 vorgerenderte weiße Stempel-Texturen (dichter Körniger Kern,
       Gauß-Nebel, unregelmäßige Kante) — pro Farbe getönt gecacht.
       Zeichnen = drawImage mit Zufallsrotation → dicht & echt bei wenig CPU. */
    function hexA(hex, a) {
      hex = hex.replace('#',''); if (hex.length===3) hex = hex.split('').map(function(c){return c+c;}).join('');
      var n = parseInt(hex,16); return 'rgba('+((n>>16)&255)+','+((n>>8)&255)+','+(n&255)+','+a+')';
    }
    function gauss() { return (Math.random()+Math.random()+Math.random()-1.5)/1.5; }
    var whiteSprites = {}, tintCache = {};
    function makeSprites(capKey) {
      var P = CAPS[capKey], out = [];
      for (var v = 0; v < 4; v++) {
        var S = Math.ceil(P.rad * P.mist * 2) + 10, cvs = document.createElement('canvas');
        cvs.width = cvs.height = S;
        var x = cvs.getContext('2d'), cx = S/2;
        var a1 = Math.random()*6.28, a2 = Math.random()*6.28;
        function edge(ang) { return 1 + 0.2*Math.sin(3*ang+a1) + 0.13*Math.sin(5*ang+a2); }
        var coreN = P.budget*7, mistN = Math.round(P.budget*7*(1.2-P.core));
        var i, ang, r;
        for (i = 0; i < coreN; i++) {
          ang = Math.random()*6.283; r = Math.sqrt(Math.random()) * P.rad * edge(ang);
          x.fillStyle = 'rgba(255,255,255,' + (0.05+Math.random()*0.11) + ')';
          x.fillRect(cx+Math.cos(ang)*r, cx+Math.sin(ang)*r, 1+Math.random()*0.8, 1+Math.random()*0.8);
        }
        for (i = 0; i < mistN; i++) {
          ang = Math.random()*6.283; r = (P.rad + Math.abs(gauss())*P.rad*(P.mist-1)) * edge(ang);
          x.fillStyle = 'rgba(255,255,255,' + (0.012+Math.random()*0.04) + ')';
          x.fillRect(cx+Math.cos(ang)*r, cx+Math.sin(ang)*r, 1, 1);
        }
        out.push(cvs);
      }
      return out;
    }
    Object.keys(CAPS).forEach(function(k){ whiteSprites[k] = makeSprites(k); });
    function tinted(capKey, color) {
      var key = capKey + color, arr = tintCache[key];
      if (arr) return arr;
      arr = whiteSprites[capKey].map(function (w) {
        var c = document.createElement('canvas'); c.width = w.width; c.height = w.height;
        var x = c.getContext('2d');
        x.drawImage(w, 0, 0); x.globalCompositeOperation = 'source-in';
        x.fillStyle = color; x.fillRect(0, 0, c.width, c.height);
        return c;
      });
      tintCache[key] = arr; return arr;
    }
    var downT = 0;
    function streak(x, y, col, rad) { // Zack-Bell-Splatter: Kreise auslaufend, schrumpfend
      var dir = Math.random()*6.283, spd = 2 + Math.random()*6, r = rad*0.22 + Math.random()*rad*0.1;
      var shrink = r/8 + Math.random()*r/6;
      pctx.fillStyle = hexA(col, 0.4);
      while (r > 0.4) {
        pctx.beginPath(); pctx.arc(x, y, r, 0, 6.283); pctx.fill();
        x += Math.cos(dir)*spd; y += Math.sin(dir)*spd; r -= shrink;
      }
    }
    function stamp(x, y, speed) {
      var P = CAPS[state.cap], erase = state.tool === 'eraser';
      var sprites = erase ? whiteSprites[state.cap] : tinted(state.cap, state.color);
      var spr = sprites[(Math.random()*sprites.length)|0];
      var pressure = Math.min(1, 0.45 + (performance.now()-downT)/220);
      var alpha = Math.max(0.1, 1/(1+speed*0.45)) * pressure;
      pctx.save(); clipStencil();
      pctx.globalCompositeOperation = erase ? 'destination-out' : 'source-over';
      pctx.globalAlpha = erase ? Math.min(1, alpha*1.6) : alpha;
      pctx.translate(x, y); pctx.rotate(Math.random()*6.283);
      pctx.drawImage(spr, -spr.width/2, -spr.height/2);
      pctx.restore();
      // Dirty-Sprenkel (Standard)
      if (!erase && P.dirty && Math.random() < P.dirty) {
        pctx.save(); clipStencil();
        var rr_ = P.rad*(2+Math.random()*2.5), ang = Math.random()*6.283;
        pctx.fillStyle = hexA(state.color, 0.25+Math.random()*0.3);
        pctx.beginPath(); pctx.arc(x+Math.cos(ang)*rr_, y+Math.sin(ang)*rr_, 0.8+Math.random()*1.2, 0, 6.283); pctx.fill();
        pctx.restore();
      }
      // Drips + Splatter: erst nach echtem Verweilen und voller Sättigung
      if (!erase && speed < 0.9 && performance.now()-downT > 400) {
        dwell++;
        if (dwell > 30 && Math.random() < 0.16 * P.drip) {
          drips.push({ x: x + (Math.random()-0.5)*P.rad*0.8, y: y + P.rad*0.4, vy: 0.2, w: Math.max(1.6, P.rad*0.14), col: state.color, life: 0, max: 30 + Math.random()*140 });
          if (Math.random() < 0.25) { pctx.save(); clipStencil(); streak(x, y, state.color, P.rad); pctx.restore(); }
          dwell = 0;
        }
      } else dwell = Math.max(0, dwell - 2);
    }
    function updateDrips() {
      if (!drips.length) return;
      pctx.save(); clipStencil();
      for (var i = drips.length-1; i >= 0; i--) {
        var d = drips[i], ny = d.y + d.vy;
        pctx.strokeStyle = hexA(d.col, 0.5); pctx.lineWidth = d.w; pctx.lineCap = 'round';
        pctx.beginPath(); pctx.moveTo(d.x, d.y); pctx.lineTo(d.x, ny); pctx.stroke();
        d.y = ny; d.vy = Math.min(2.4, d.vy + 0.05); d.life += d.vy;
        if (d.life >= d.max || d.y > H) {
          pctx.fillStyle = hexA(d.col, 0.55); pctx.beginPath(); pctx.arc(d.x, d.y, d.w*0.9, 0, 6.283); pctx.fill();
          drips.splice(i, 1);
        }
      }
      pctx.restore();
    }

    /* ================= POINTER ================= */
    function pos(e) { var r = paint.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
    function down(e) {
      if (e.button !== undefined && e.button !== 0) return;
      spraying = true; dwell = 0; downT = performance.now();
      try { paint.setPointerCapture(e.pointerId); } catch (er) {}
      pushUndo();
      // Sound-Default: Owner-Wunsch "Sound direkt an" — Autoplay-Policy erlaubt keinen Ton
      // vor der ersten Nutzer-Geste, darum an ab dem ersten Sprüh-Klick, ausser der User
      // hat Sound bereits selbst ausgeschaltet.
      if (!state.sound && !state.soundUserSet) {
        state.sound = true;
        var sndBtn = document.getElementById('ss-sound');
        if (sndBtn) { sndBtn.classList.remove('off'); sndBtn.setAttribute('aria-pressed', 'true'); }
      }
      var p = pos(e); last = p; stamp(p.x, p.y, 0); hiss(true); moveCap(e);
    }
    function move(e) {
      moveCap(e);
      if (!spraying) return;
      var p = pos(e), dx = p.x-last.x, dy = p.y-last.y, dlen = Math.hypot(dx, dy);
      var step = Math.max(1.5, CAPS[state.cap].rad * 0.3);
      var steps = Math.max(1, Math.floor(dlen / step));
      var sp = dlen / steps;
      for (var s = 1; s <= steps; s++) stamp(last.x + dx*s/steps, last.y + dy*s/steps, sp);
      last = p;
    }
    function up() { spraying = false; last = null; hiss(false); }
    function moveCap(e) {
      var r = stage.getBoundingClientRect();
      var d = CAPS[state.cap].rad * 2;
      cap.style.width = d + 'px'; cap.style.height = d + 'px';
      cap.style.transform = 'translate(' + (e.clientX - r.left) + 'px,' + (e.clientY - r.top) + 'px) translate(-50%,-50%)';
      cap.style.borderColor = state.tool === 'eraser' ? 'rgba(255,255,255,.9)' : state.color;
      cap.classList.toggle('erase', state.tool === 'eraser');
    }
    paint.addEventListener('pointerdown', down);
    paint.addEventListener('pointermove', move, { passive: true });
    window.addEventListener('pointerup', up);
    paint.addEventListener('pointerenter', function(){ cap.style.opacity = 1; });
    paint.addEventListener('pointerleave', function(){ if(!spraying) cap.style.opacity = 0; });

    /* ================= UNDO / CLEAR ================= */
    function pushUndo() { try { undoStack.push(pctx.getImageData(0,0,paint.width,paint.height)); if (undoStack.length>12) undoStack.shift(); } catch(e){} }
    function undo() { var img = undoStack.pop(); if (img) { drips.length=0; pctx.setTransform(1,0,0,1,0,0); pctx.putImageData(img,0,0); pctx.setTransform(dpr,0,0,dpr,0,0); } }
    function clearAll() { pushUndo(); drips.length=0; pctx.clearRect(0,0,W,H); }

    /* ================= AUDIO ================= */
    var actx, filt, gain, started = false;
    function audioInit() {
      if (started) return; started = true;
      try {
        actx = new (window.AudioContext || window.webkitAudioContext)();
        var buf = actx.createBuffer(1, actx.sampleRate*1.2, actx.sampleRate), dt = buf.getChannelData(0);
        for (var i=0;i<dt.length;i++) dt[i] = Math.random()*2-1;
        var noise = actx.createBufferSource(); noise.buffer = buf; noise.loop = true;
        filt = actx.createBiquadFilter(); filt.type='bandpass'; filt.Q.value=0.7;
        gain = actx.createGain(); gain.gain.value = 0;
        noise.connect(filt); filt.connect(gain); gain.connect(actx.destination); noise.start();
      } catch (e) { started = false; }
    }
    function hiss(on) {
      if (!state.sound) { if (gain) gain.gain.value = 0; return; }
      audioInit(); if (!actx) return;
      if (actx.state === 'suspended') actx.resume();
      filt.frequency.value = { skinny: 6400, standard: 6000, soft: 5200, fat: 4300 }[state.cap] || 5200;
      gain.gain.setTargetAtTime(on ? 0.05 : 0, actx.currentTime, 0.03);
    }

    /* ================= SAVE / SHARE ================= */
    var isEN = /^\/en\//.test(window.location.pathname);
    var DE_MAIL_BODY = 'Hey!\n\nLass uns doch mal zusammen eine Runde sprühen gehen. Hier ist mein Artwork — hab schon mal angefangen zu üben (hängt als Bild an, liegt frisch in meinen Downloads).\n\nProbier du auch mal: https://www.brain2canvas.com/spray-studio\n\nUnd in echt geht das als Teamevent mit Brain2Canvas: https://www.brain2canvas.com\n\nBock?';
    var SHARE_URL = 'https://www.brain2canvas.com/pages/spray-studio?utm_source=spray-share&utm_medium=referral&utm_campaign=spray-studio';
    var T = isEN ? {
      shareTitle: 'My Brain2Canvas tag',
      shareText: "Just sprayed my own tag on Brain2Canvas 🎨 Try it yourself, and let's turn this into a team workshop:",
      mailSubject: "Let's go spray together 🎨",
      copied: 'Link copied ✓',
      sent: 'Sent ✓',
      saved: 'Tag saved ✓',
      mailBtn: 'Send by email',
      copyBtn: 'Copy link',
      nudge: 'Want this for real? Ask us, no strings attached',
      nudgeCTA: 'Ask, no obligation',
      surfaces: ["Concrete wall", "Berlin subway", "Giant sticker", "NYC storefront"],
      stencils: {"star": "Star", "bolt": "Bolt", "heart": "Heart", "crown": "Crown"},
      stencilOn: ["", " stencil in place, spray over it!"],
      stencilOff: "Stencil off ✓",
      mailBody: "Hey!\n\nLet's go spray a wall together some time. Here is my piece, I already had a first go (attached as an image, it just landed in my downloads).\n\nTry it yourself: https://www.brain2canvas.com/en/pages/spray-studio\n\nAnd for real, this works as a team event with Brain2Canvas: https://www.brain2canvas.com/en\n\nUp for it?",
      mailOpened: "Email opened, attach the image and go ✓",
      fileName: "my-tag-brain2canvas.png",
      shareUrl: "https://www.brain2canvas.com/en/pages/spray-studio?utm_source=spray-share&utm_medium=referral&utm_campaign=spray-studio"
    } : {
      shareTitle: 'Mein Brain2Canvas Tag',
      shareText: "Hab gerade bei Brain2Canvas mein eigenes Tag gesprüht 🎨 Probier's aus und lass uns das mal als Team-Workshop machen:",
      mailSubject: 'Lass uns mal zusammen sprühen gehen 🎨',
      copied: 'Link kopiert ✓',
      sent: 'Verschickt ✓',
      saved: 'Tag gespeichert ✓',
      mailBtn: 'Per E-Mail senden',
      copyBtn: 'Link kopieren',
      nudge: 'Als echtes Team-Event? Unverbindlich anfragen',
      nudgeCTA: 'Jetzt unverbindlich anfragen',
      surfaces: ["Beton-Wand", "U-Bahn Berlin", "Riesen-Sticker", "NYC Storefront"],
      stencils: { star: 'Stern', bolt: 'Blitz', heart: 'Herz', crown: 'Krone' },
      stencilOn: ["Stencil „", "“ aufgelegt — sprüh drüber!"],
      stencilOff: "Stencil abgenommen ✓",
      mailBody: DE_MAIL_BODY,
      mailOpened: "E-Mail geöffnet — Bild anhängen & los ✓",
      fileName: "mein-tag-brain2canvas.png",
      shareUrl: "https://www.brain2canvas.com/pages/spray-studio?utm_source=spray-share&utm_medium=referral&utm_campaign=spray-studio"
    };
    SHARE_URL = T.shareUrl;
    function compose() {
      var fh = Math.round(bg.height*0.075);
      var out = document.createElement('canvas'); out.width = bg.width; out.height = bg.height + fh;
      var o = out.getContext('2d'); o.drawImage(bg, 0, 0); o.drawImage(paint, 0, 0);
      // gebrandete Fußleiste (Watermark — Lead-Träger, egal wo das Bild landet)
      o.fillStyle = '#0e0e10'; o.fillRect(0, bg.height, out.width, fh);
      o.fillStyle = '#fbe785'; o.fillRect(0, bg.height, out.width, Math.max(3, fh*0.07));
      // kleines Drip-Logo (dezenter Tropfen unter dem Farbring)
      var dcx = out.width*0.03 + 3, dcy = bg.height + fh*0.78, dr = fh*0.09;
      o.fillStyle = '#fbe785';
      o.beginPath(); o.arc(dcx, dcy, dr, 0, Math.PI*2); o.fill();
      o.beginPath();
      o.moveTo(dcx - dr*0.55, dcy + dr*0.2);
      o.quadraticCurveTo(dcx, dcy + dr*2.4, dcx + dr*0.55, dcy + dr*0.2);
      o.quadraticCurveTo(dcx, dcy + dr*0.9, dcx - dr*0.55, dcy + dr*0.2);
      o.fill();
      var fs = fh*0.34;
      o.font = '800 ' + fs + "px 'Unbounded',sans-serif"; o.textBaseline = 'middle';
      o.textAlign = 'left'; o.fillStyle = '#f3f1e9';
      o.fillText('SPRAY', out.width*0.03, bg.height+fh*0.55);
      var w1 = o.measureText('SPRAY').width;
      o.fillStyle = '#fbe785'; o.fillText('STUDIO', out.width*0.03+w1, bg.height+fh*0.55);
      o.textAlign = 'right'; o.fillStyle = 'rgba(243,241,233,.75)';
      o.font = '700 ' + fh*0.28 + "px 'Unbounded',sans-serif";
      o.fillText('brain2canvas.com/spray-studio', out.width*0.97, bg.height+fh*0.55);
      o.textBaseline = 'alphabetic';
      return out;
    }
    var toastT, ctaShown = false;
    function showCTA(delay) {
      if (ctaShown) return; ctaShown = true;
      setTimeout(function () {
        var m = document.getElementById('ss-cta'); if (!m) return;
        m.hidden = false;
        if (window.lucide) lucide.createIcons();
      }, delay || 900);
    }
    function toast(msg) {
      var t = document.getElementById('ss-toast'); if (!t) return;
      t.textContent = msg; t.classList.add('show');
      clearTimeout(toastT); toastT = setTimeout(function(){ t.classList.remove('show'); }, 2200);
    }
    function save() { var a = document.createElement('a'); a.download = T.fileName; a.href = compose().toDataURL('image/png'); a.click(); toast(T.saved); showCTA(1300); }
    function shareFallback() {
      // Kein navigator.share (Desktop u.ä.): Buttons „Per E-Mail senden“ + „Link kopieren“, plus Bild-Download
      save();
      var box = document.getElementById('ss-share-fallback'); if (!box) return;
      box.hidden = false;
      var mailBtn = document.getElementById('ss-share-mail');
      var copyBtn = document.getElementById('ss-share-copy');
      if (mailBtn) {
        mailBtn.textContent = T.mailBtn;
        mailBtn.onclick = function () {
          var sub = encodeURIComponent(T.mailSubject);
          var body = encodeURIComponent(T.shareText + '\n\n' + SHARE_URL);
          window.location.href = 'mailto:?subject=' + sub + '&body=' + body;
        };
      }
      if (copyBtn) {
        copyBtn.textContent = T.copyBtn;
        copyBtn.onclick = function () {
          var done = function(){ toast(T.copied); };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(SHARE_URL).then(done).catch(done);
          } else { done(); }
        };
      }
      showCTA(600);
    }
    function share() {
      compose().toBlob(function (blob) {
        var file = new File([blob], 'brain2canvas-tag.png', { type: 'image/png' });
        var payload = { title: T.shareTitle, text: T.shareText, url: SHARE_URL };
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          payload.files = [file];
          navigator.share(payload).then(function(){ toast(T.sent); showCTA(1300); }).catch(function(err){
            if (err && err.name === 'AbortError') return;
            navigator.share({ title: T.shareTitle, text: T.shareText, url: SHARE_URL }).then(function(){ toast(T.sent); showCTA(1300); }).catch(function(){ shareFallback(); });
          });
        } else if (navigator.share) {
          navigator.share(payload).then(function(){ toast(T.sent); showCTA(1300); }).catch(function(err){
            if (err && err.name === 'AbortError') return;
            shareFallback();
          });
        } else { shareFallback(); }
      }, 'image/png');
    }

    /* ================= UI ================= */
    function shade(hex, f) { // f: -1..1
      hex = hex.replace('#',''); if (hex.length===3) hex = hex.split('').map(function(c){return c+c;}).join('');
      var n = parseInt(hex,16), r=(n>>16)&255, g=(n>>8)&255, b=n&255;
      function m(ch){ return Math.round(f<0 ? ch*(1+f) : ch+(255-ch)*f); }
      return 'rgb('+m(r)+','+m(g)+','+m(b)+')';
    }
    function buildCan(b, i) {
      // Montana-Black-Stil: schwarzer Körper, bunter Cap + Farbring
      var c = b.getAttribute('data-color');
      b.innerHTML =
        '<svg viewBox="0 0 26 56" width="100%" height="100%" aria-hidden="true">' +
        '<defs><linearGradient id="cb'+i+'" x1="0" x2="1" y1="0" y2="0">' +
        '<stop offset="0" stop-color="#050507"/><stop offset="0.26" stop-color="#3c3c44"/>' +
        '<stop offset="0.5" stop-color="#17171c"/><stop offset="1" stop-color="#000"/></linearGradient>' +
        '<linearGradient id="cc'+i+'" x1="0" x2="1" y1="0" y2="0">' +
        '<stop offset="0" stop-color="'+shade(c,-0.5)+'"/><stop offset="0.32" stop-color="'+shade(c,0.45)+'"/>' +
        '<stop offset="0.6" stop-color="'+c+'"/><stop offset="1" stop-color="'+shade(c,-0.6)+'"/></linearGradient>' +
        '<linearGradient id="cm'+i+'" x1="0" x2="1" y1="0" y2="0">' +
        '<stop offset="0" stop-color="#55555c"/><stop offset="0.3" stop-color="#d9d9e0"/>' +
        '<stop offset="0.55" stop-color="#a2a2ab"/><stop offset="1" stop-color="#3c3c42"/></linearGradient></defs>' +
        '<rect x="11.6" y="0" width="2.8" height="2.4" fill="#2c2c31"/>' +
        '<rect x="8" y="2.2" width="10" height="8.2" rx="1.6" fill="url(#cc'+i+')"/>' +
        '<rect x="8" y="9" width="10" height="1.4" fill="rgba(0,0,0,.35)"/>' +
        '<path d="M8 10.4 L4.5 15.2 L21.5 15.2 L18 10.4 Z" fill="url(#cm'+i+')"/>' +
        '<rect x="4" y="14.8" width="18" height="2.4" rx="1" fill="url(#cm'+i+')"/>' +
        '<rect x="4" y="17.2" width="18" height="33.5" fill="url(#cb'+i+')"/>' +
        '<rect x="4" y="20" width="18" height="1" fill="rgba(255,255,255,.14)"/>' +
        '<circle cx="13" cy="36" r="4.6" fill="'+c+'" stroke="rgba(255,255,255,.5)" stroke-width="0.8"/>' +
        '<rect x="4" y="50.5" width="18" height="3.8" rx="1.7" fill="url(#cm'+i+')"/></svg>';
    }
    function setColor(c, el) { state.color = c; state.tool = 'spray'; document.querySelectorAll('.ss-color').forEach(function(b){ b.classList.toggle('on', b===el); }); document.querySelectorAll('[data-tool]').forEach(function(b){ b.classList.remove('on'); }); }
    document.querySelectorAll('.ss-color').forEach(function (b, i) { buildCan(b, i); b.addEventListener('click', function () { setColor(b.getAttribute('data-color'), b); }); });
    document.querySelectorAll('.ss-cap').forEach(function (b) { b.addEventListener('click', function () { state.cap = b.getAttribute('data-cap'); document.querySelectorAll('.ss-cap').forEach(function(x){x.classList.toggle('on', x===b);}); }); });
    document.querySelectorAll('[data-tool]').forEach(function (b) { b.addEventListener('click', function () { state.tool = b.getAttribute('data-tool'); document.querySelectorAll('[data-tool]').forEach(function(x){x.classList.toggle('on', x===b);}); document.querySelectorAll('.ss-color').forEach(function(x){x.classList.remove('on');}); }); });
    var u = document.getElementById('ss-undo'); if (u) u.addEventListener('click', undo);
    var cl = document.getElementById('ss-clear'); if (cl) cl.addEventListener('click', clearAll);
    var sv = document.getElementById('ss-save'); if (sv) sv.addEventListener('click', save);
    var sh = document.getElementById('ss-share'); if (sh) sh.addEventListener('click', share);
    var sh2 = document.getElementById('ss-share2'); if (sh2) sh2.addEventListener('click', share);
    var snd = document.getElementById('ss-sound'); if (snd) snd.addEventListener('click', function () { state.sound = !state.sound; state.soundUserSet = true; snd.classList.toggle('off', !state.sound); snd.setAttribute('aria-pressed', state.sound); if (!state.sound && gain) gain.gain.value = 0; });
    var ctax = document.getElementById('ss-cta-x'); if (ctax) ctax.addEventListener('click', function(){ document.getElementById('ss-cta').hidden = true; });
    var ctam = document.getElementById('ss-cta'); if (ctam) ctam.addEventListener('click', function(e){ if (e.target === ctam) ctam.hidden = true; });
    // Lead-Mail: Artwork runterladen + vorgefertigte E-Mail öffnen
    var ctaSend = document.getElementById('cta-send');
    if (ctaSend) ctaSend.addEventListener('click', function () {
      var inp = document.getElementById('cta-email'), em = (inp.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) { inp.classList.add('err'); inp.focus(); return; }
      inp.classList.remove('err');
      var a = document.createElement('a'); a.download = T.fileName; a.href = compose().toDataURL('image/png'); a.click();
      var sub = encodeURIComponent(T.mailSubject);
      var body = encodeURIComponent(T.mailBody);
      window.location.href = 'mailto:' + em + '?subject=' + sub + '&body=' + body;
      toast(T.mailOpened);
    });
    var pv = document.getElementById('ss-prev'); if (pv) pv.addEventListener('click', function(){ setSurface(state.surface-1); drawStencil(); });
    var nx = document.getElementById('ss-next'); if (nx) nx.addEventListener('click', function(){ setSurface(state.surface+1); drawStencil(); });
    // Stencils
    var STEN_NAMES = T.stencils;
    document.querySelectorAll('.ss-sten').forEach(function (b) {
      var k = b.getAttribute('data-sten');
      b.innerHTML = '<svg viewBox="-0.1 -0.1 1.2 1.2"><path d="'+STENCILS[k]+'"></path></svg>';
      b.setAttribute('aria-label', 'Stencil: '+STEN_NAMES[k]);
      b.addEventListener('click', function () {
        state.stencil = (state.stencil === k) ? null : k;
        document.querySelectorAll('.ss-sten').forEach(function(x){ x.classList.toggle('on', x.getAttribute('data-sten')===state.stencil); });
        drawStencil();
        toast(state.stencil ? T.stencilOn[0]+STEN_NAMES[k]+T.stencilOn[1] : T.stencilOff);
      });
    });

    // Stencil verschieben (Owner-Auftrag: Stencils müssen bewegbar sein)
    (function () {
      if (!stenDrag) return;
      var dragging = false, sx = 0, sy = 0, ox = 0, oy = 0;
      stenDrag.addEventListener('pointerdown', function (e) {
        dragging = true; sx = e.clientX; sy = e.clientY; ox = state.stenX; oy = state.stenY;
        try { stenDrag.setPointerCapture(e.pointerId); } catch (er) {}
        e.preventDefault();
      });
      stenDrag.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        state.stenX = ox + (e.clientX - sx); state.stenY = oy + (e.clientY - sy);
        var maxX = W * 0.42, maxY = H * 0.42;
        state.stenX = Math.max(-maxX, Math.min(maxX, state.stenX));
        state.stenY = Math.max(-maxY, Math.min(maxY, state.stenY));
        drawStencil();
      });
      function stopDrag() { dragging = false; }
      stenDrag.addEventListener('pointerup', stopDrag);
      stenDrag.addEventListener('pointercancel', stopDrag);
    })();

    // Werkzeugleiste andocken (oben/unten) + einklappen (Owner-Auftrag: Bar darf die Bahn nie dauerhaft verdecken)
    (function () {
      var bar = document.getElementById('ss-bar');
      var dockBtn = document.getElementById('ss-dock');
      var collapseBtn = document.getElementById('ss-collapse');
      var reopenBtn = document.getElementById('ss-bar-reopen');
      if (!bar) return;
      var DOCK_KEY = 'ss-dock-pos', COLLAPSE_KEY = 'ss-bar-collapsed';
      function applyDock(pos) {
        bar.classList.toggle('dock-top', pos === 'top');
        try { localStorage.setItem(DOCK_KEY, pos); } catch (e) {}
      }
      function applyCollapse(collapsed) {
        bar.classList.toggle('collapsed', collapsed);
        if (reopenBtn) reopenBtn.classList.toggle('show', collapsed);
        try { localStorage.setItem(COLLAPSE_KEY, collapsed ? '1' : '0'); } catch (e) {}
      }
      var savedPos = 'bottom', savedCollapsed = false;
      try { savedPos = localStorage.getItem(DOCK_KEY) || 'bottom'; savedCollapsed = localStorage.getItem(COLLAPSE_KEY) === '1'; } catch (e) {}
      applyDock(savedPos); applyCollapse(savedCollapsed);
      if (dockBtn) dockBtn.addEventListener('click', function () {
        applyDock(bar.classList.contains('dock-top') ? 'bottom' : 'top');
      });
      if (collapseBtn) collapseBtn.addEventListener('click', function () { applyCollapse(true); });
      if (reopenBtn) reopenBtn.addEventListener('click', function () { applyCollapse(false); });
    })();

    /* ================= LOOP ================= */
    function loop() { updateDrips(); requestAnimationFrame(loop); }
    new ResizeObserver(resize).observe(stage);
    resize(); requestAnimationFrame(loop);

    var firstColor = document.querySelector('.ss-color[data-color="' + state.color + '"]') || document.querySelector('.ss-color');
    if (firstColor) setColor(firstColor.getAttribute('data-color'), firstColor);
    var defCap = document.querySelector('.ss-cap[data-cap="' + state.cap + '"]'); if (defCap) defCap.classList.add('on');
    // Hint kurz zeigen, dann weg (auch beim ersten Sprühen)
    var hint = document.querySelector('.ss-hint');
    if (hint) {
      var hideHint = function(){ hint.classList.add('hide'); var c = document.getElementById('ss-share2'); if (c) c.classList.add('show'); };
      setTimeout(hideHint, 4500);
      paint.addEventListener('pointerdown', hideHint, { once: true });
    }
  });
})();
